module.exports = __webpack_public_path__ + "img/ROC.898c4482.png";